import { EasmBulkChangeInvestigationPropertyDataProvider } from './EasmBulkChangeInvestigationPropertyDataProvider';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType } from '../../types';

export class EasmBulkChangePriorityDataProvider extends EasmBulkChangeInvestigationPropertyDataProvider {
  public getTitle(): string {
    return translateFn('Change priority?');
  }

  public getDescription(findingsClassType: FindingClassType, preSelectedValueLabel: string | null): string {
    if (FindingClassType.ASSET === findingsClassType) {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The priority of the selected assets will change to <b>{priority}</b>.',
          { priority: preSelectedValueLabel }
        )
        : translateFn('Select the priority for this asset.');
    } else {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The priority of the selected artifacts will change to <b>{priority}</b>.',
          { priority: preSelectedValueLabel }
        )
        : translateFn('Select the priority for this artifact.');
    }
  }

  public getOptionsLabel(): string {
    return translateFn('Priority');
  }

  public getOptionsPlaceholder(): string {
    return translateFn('Select priority');
  }

  public getRequiredOptionErrorMessage(): string {
    return translateFn('Please select a priority.');
  }

  public getApplyToArtifactsOptionLabel(): string {
    return translateFn('Apply note and priority also to asset artifacts');
  }

  public getSuccessToastMessage(response: any): string {
    return translateFn('Priority changed successfully.');
  }

  public getFailureToastMessage(error: any, value: any): string {
    return translateFn('Failed to change the priority.');
  }

  protected getApiInvestigationProperty(): string {
    return 'priority';
  }
}
